import { render, staticRenderFns } from "./CustomerContactEdit.vue?vue&type=template&id=2a3ddcd5&"
import script from "./CustomerContactEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports